import { Approver } from './Approver.model';
export class Cnae {
    _id: string;
    name: String;
    type: Number = 0;
    active: boolean;
    sapItemCode: String;
    cnae: String = '-';
    sapKey: String = '-1';

    loadFromServer(r: any) {

        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.sapItemCode)
            this.sapItemCode = r.sapItemCode;

        if (r.cnae)
            this.cnae = r.cnae;

        if (r.sapKey)
            this.sapKey = r.sapKey;

        if(r.active)
            this.active = r.active;

        if(r.type)
            this.type = parseInt(r.type);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Cnae.model.ts